import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { APIProviderService } from 'src/app/providers/api/api.provider.service';

@Injectable({
  providedIn: 'root'
})
export abstract class ApiService<T, S extends APIProviderService<T>> {
  protected abstract get provider(): S;
  public values = signal<T[]>([]);

  async cacheData(retailerIframeID: string | null) {
    this.values.set(await this.provider.get(retailerIframeID));
  }
}
